import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
const natConfigurationTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'NAT Configuration',
  key: 'natConfigurationTemplate',
  private: {
    metadata: {
      layout: {
        rows: [
          ['id'],
          ['PRIVATEIP', 'PRIVATEPORT', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true',
      },
      PRIVATEIP: {
        label: 'Private Port ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'IPAddress',
              invalidIPs: [
                '255.255.255.255',
              ],
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      PRIVATEPORT: {
        label: 'Private Port',
        type: 'text',
        initial: '',
        validation: {
          required: true,
        },
      },
    },
  },
  public: {
    metadata: {
      layout: {
        rows: [
          ['PUBLICIP', 'PUBLICPORT', '$empty', '$empty'],
        ],
      },
    },
    fields: {
      PUBLICIP: {
        label: 'Public Port ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50,
            },
            {
              type: 'IPAddress',
              invalidIPs: [
                '255.255.255.255',
              ],
              errorMessage: 'Must be a valid IP Address. Please re-enter.',
            },
          ],
        },
      },
      PUBLICPORT: {
        label: 'Public Port',
        type: 'text',
        initial: '',
        validation: {
          required: true,
        },
      },
    },
  },
};

export default natConfigurationTemplate;
